import React, { useMemo, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ProjectsService from "../Services/ProjectsService";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import GraphService from "../Services/GraphService";

interface SendCustomerMailModalProps {
  code: string;
  afterSave: Function;
  afterCancel: Function;
}

const SendCustomerMailModal = (props: SendCustomerMailModalProps) => {
  const { instance } = useMsal();

  const graphService = useMemo(() => new GraphService(instance), [instance]);
  const projectsService = useMemo(
    () => new ProjectsService(instance),
    [instance]
  );

  const [templateType, setTemplateType] = useState<string>("Customer");
  const [extraInfo, setExtraInfo] = useState<string>("");

  const [visible, setVisible] = useState<boolean>(true);

  function toggle() {
    setVisible(!visible);
    props.afterCancel();
  }

  async function save() {
    try {
      if (props.code !== null) {
        const user = await graphService.getUserDetails();
        const success = await projectsService.sendCustomerEmail(
          props.code,
          user.mail ?? user.userPrincipalName ?? "",
          user.id ?? "",
          templateType,
          extraInfo
        );

        if (!success) {
          toast.error("Fout bij versturen van email.");
        } else {
          setVisible(false);
          props.afterSave();
        }
      }
    } catch (err) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }

  return (
    <Modal isOpen={visible} toggle={toggle} className="mw-100 w-75">
      <ModalHeader toggle={toggle}>
        {props.code} - Email naar klant versturen?
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-group">
            <label className="my-1 mr-2">Email template type</label>
            <select
              className="form-control"
              id="leaveTypeSelect"
              defaultValue={templateType}
              onChange={(e) => setTemplateType(e.target.value)}
            >
              <option value="Customer">Klant</option>;
              <option value="ProjectCustomer">Project klant</option>;
            </select>
          </div>
          <div className="form-group">
            <label className="my-1 mr-2">Extra informatie</label>
            <textarea
              className="form-control my-1 mr-sm-2"
              title="Extra informatie"
              style={{ height: "200px" }}
              onChange={(e) => setExtraInfo(e.target.value)}
              value={extraInfo}
            ></textarea>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={save}>
          Verzenden
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Sluiten
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SendCustomerMailModal;
